import { render } from "./NotPermissionPage.vue?vue&type=template&id=8197d08c&scoped=true"
import script from "./NotPermissionPage.vue?vue&type=script&lang=js"
export * from "./NotPermissionPage.vue?vue&type=script&lang=js"

import "./NotPermissionPage.vue?vue&type=style&index=0&id=8197d08c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8197d08c"]])

export default __exports__